const highGrade = 5

class ShopPage {
  constructor() {
    this.id = $('.header-shop-data').data('shop-id')
    this.currentEvaluationsPage = 1
    this.initTabs()
    this.toggleShowMoreEvaluations()
  }

  initTabs() {
    $('.header-shop-data .logo').on('click', function (e) {
      $('.nav-tabs a[href="#tab2"]').trigger('click');
    })
    $('.header-shop-data .title-yotpo h1').on('click', function (e) {
      $('.nav-tabs a[href="#tab2"]').trigger('click');
    })
    $('.header-shop-data .yotpo-box-wrap').on('click', function (e) {
      $('.nav-tabs a[href="#tab3"]').trigger('click');
    })
    $('.nav-tabs a').on('click', (e) => {
      if (e.currentTarget.attributes.href.value === '#tab3') {
        $('.header-shop-data-details .yotpo-box-wrap').addClass('hide')
        this.truncateLongText()
      }
      else {
        $('.header-shop-data-details .yotpo-box-wrap').removeClass('hide')
      }
    })
  }

  toggleShowMoreEvaluations() {
    $('.btn-more-evaluations').click((e) => {
      var el = $(e.currentTarget)
      el.blur()
      this.currentEvaluationsPage++

      this.getMoreEvaluations((result, isThereMore) => {
        var html = ''
        result.forEach(function (item) {
          var compiledTemplate = Handlebars.getSharedTemplate('evaluations')
          var resultHtml = compiledTemplate({
            evaluation: item,
            lastname: item.lastname ? item.lastname[0] : '',
            publicationDate: new Date(item.date).toLocaleDateString('en-GB'),
            highGrade
          })
          html = html.concat(resultHtml)
        })
        $('.client-opinion-wrapper').append(html)
        el.toggleClass('hide', !isThereMore)
        this.truncateLongText()
      })
    })
  }

  getMoreEvaluations (callback) {
    $.get(SP.config.evaluationSearchUrl, this.buildQuery(), (data) => {
      callback(data.miraklEvaluationsForShop.evaluations, this.hasMoreEvaluationsPages(data.numberOfPages))
    })
  }

  hasMoreEvaluationsPages (numberOfPages) {
    return numberOfPages > this.currentEvaluationsPage
  }

  buildQuery () {
    if (!this.id) return
    return `page=${this.currentEvaluationsPage}&shop=${this.id}`
  }

  truncateLongText () {
    setTimeout(function () {
      $('#tab3 .client-comments .opinion p').truncate({
        lines: 3,
        showMore: '<a class="show-more" href="">קרא עוד</a>',
      })
    })

    setTimeout(function () {
      $('#tab3 .client-comments .opinion p .show-more').click((e) => {
        e.preventDefault()
        $(e.currentTarget).parent().truncate('expand')
      })
    })
  }
}

$(() => {
  if ($('.activateSearchPageJs').length && $('#searchResults').length && $('.shop-data').length) {
    new ShopPage()
  }
})